var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeachers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 132,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.256 7.556a14.18 14.18 0 00-6.487-2.368c-13.091-1.444-19.747 16.398-22.521 26.344-2.868 10.278-7.985 19.065-18.962 21.965-7.168 1.894-14.791 1.03-22.02-.647-16.235-3.768-41.589-14.902-53.188 3.661-3.551 5.674-4.494 12.728-3.492 19.333a36.598 36.598 0 0015.241 24.371c18.741 12.902 37.897 3.299 52.298-11.114 15.521-15.541 29.003-30.87 48.166-42.394 4.368-2.632 8.905-5.106 12.578-8.645 8.373-8.076 8.582-23.566-1.613-30.506z",
    fill: "#00A1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M141.256 7.556a14.18 14.18 0 00-6.487-2.368c-13.091-1.444-19.747 16.398-22.521 26.344-2.868 10.278-7.985 19.065-18.962 21.965-7.168 1.894-14.791 1.03-22.02-.647-16.235-3.768-41.589-14.902-53.188 3.661-3.551 5.674-4.494 12.728-3.492 19.333a36.598 36.598 0 0015.241 24.371c18.741 12.902 37.897 3.299 52.298-11.114 15.521-15.541 29.003-30.87 48.166-42.394 4.368-2.632 8.905-5.106 12.578-8.645 8.373-8.076 8.582-23.566-1.613-30.506z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.499 132c42.249 0 76.499-2 76.499-4.466 0-2.467-34.25-4.467-76.5-4.467-42.248 0-76.498 2-76.498 4.467C0 130 34.25 132 76.499 132z",
    fill: "#F5F5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.953 112.257V68.651h-4.34v43.606l-2.761.848v1.314h9.863v-1.314l-2.762-.848zM60.715 68.651h-4.34v43.606l-2.762.848v1.314h9.864v-1.314l-2.762-.848V68.651z",
    fill: "#2E353A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.953 73.78h-4.34v38.477l-2.761.848v1.314h9.863v-1.314l-2.762-.848V73.78zM60.715 73.78h-4.34v38.477l-2.762.848v1.314h9.864v-1.314l-2.762-.848V73.78z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129.367 70.23V0H42.961v70.23h86.406z",
    fill: "#2E353A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M129.367 70.23V0H42.961v70.23h86.406z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M127.446 1.95H44.883V68.24h82.563V1.949z",
    fill: "#00F2A4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M127.446 1.95H44.883V68.24h82.563V1.949z",
    fill: "#00F2A4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M127.446 1.95H44.883V68.24h82.563V1.949z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49.492,
    y: 9.889,
    width: 73.138,
    height: 1.508,
    rx: 0.754,
    fill: "#00F2A4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49.492,
    y: 32.509,
    width: 73.138,
    height: 1.508,
    rx: 0.754,
    fill: "#00F2A4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 49.492,
    y: 14.413,
    width: 73.138,
    height: 1.508,
    rx: 0.754,
    fill: "#00F2A4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 49.492,
    y: 37.033,
    width: 73.138,
    height: 1.508,
    rx: 0.754,
    fill: "#00F2A4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 49.492,
    y: 18.937,
    width: 73.138,
    height: 1.508,
    rx: 0.754,
    fill: "#00F2A4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 49.492,
    y: 41.557,
    width: 73.138,
    height: 1.508,
    rx: 0.754,
    fill: "#00F2A4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 49.492,
    y: 23.461,
    width: 39.962,
    height: 1.508,
    rx: 0.754,
    fill: "#00F2A4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 49.492,
    y: 46.081,
    width: 39.962,
    height: 1.508,
    rx: 0.754,
    fill: "#00F2A4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96.326 37.727l-6.092-3.551c-.971.072-1.947.027-2.908-.134-1.578-.273-1.917-.288-1.728-1.531.19-1.243-.075-2.9.395-3.074.47-.173 3.791 1.227 4.367 2.178l6.147 2.198-.181 3.914z",
    fill: "#B97964"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M114.375 31.71v7.102s-1.515.5-3.397 1.026c-2.158.6-4.798 1.23-6.171 1.183-2.564-.126-11.245-4.632-11.245-4.632l1.579-3.006s9.469 3.227 10.652 2.994c1.184-.233 8.582-4.667 8.582-4.667z",
    fill: "#00A1FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M114.374 35.17v3.646s-1.515.5-3.397 1.025c.694-2.114 2.426-3.839 3.397-4.671z",
    fill: "#000"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M115.95 56.989s-4.277 22.789-5.418 32.147c-1.491 12.208-7.587 30.065-7.587 30.065l2.439.631s8.593-15.174 10.258-28.83c6.826-13.955 7.374-31.141 7.374-31.141l-7.066-2.872z",
    fill: "#B97964"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M98.427 124.725a3.502 3.502 0 011.25-.316s1.5-.884 2.988-4.309h1.669a1.383 1.383 0 011.282.92.798.798 0 01.047.232 9.395 9.395 0 01-.126 1.184 34.085 34.085 0 01-.978 3.946l-.285-.075.517-2.49c.17-.848-.718-.032-1.132.825-.414.856-1.046 1.712-2.888 1.29-2.15-.509-3.019-.821-2.344-1.207z",
    fill: "#2E353A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M120.406 56.626s.533 23.18 1.354 32.573c1.065 12.251-1.208 30.984-1.208 30.984l2.517.111s5.268-16.623 4.084-30.33c3.792-15.067.789-31.993.789-31.993l-7.536-1.345z",
    fill: "#B97964"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M116.637 125.49a3.558 3.558 0 011.212-.454s1.396-1.037 2.501-4.604l1.661-.189a1.37 1.37 0 011.373.789.76.76 0 01.071.224c.026.404.026.808 0 1.212a33.862 33.862 0 01-.544 4.012l-.292-.043.244-2.533c.079-.86-.718.051-1.037.943-.32.892-.853 1.815-2.735 1.598-2.185-.284-3.081-.497-2.454-.955zM128.902 17.194s1.251.068 2.305 2.123c1.053 2.056-.265 4.34-.529 5.433-.265 1.093-1.578 2.06.592 3.713s3.472 3.409 1.712 5.196.174 3.156-2.367 4.482-11.904-.659-13.087-3.224c-1.184-2.564.244-4.513.319-5.279.075-.765-1.503-1.55-1.898-4.056-.394-2.505 1.626-3.041 1.898-4.186.272-1.144-.994-2.588 0-5.022.994-2.435 10.921-2.96 11.055.82z",
    fill: "#2E353A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M135.203 51.327c-1.495.193-3.223-2.727-4.474-5.449-1.069-2.308-1.815-4.478-1.815-4.478l.789-2.225 2.06-5.808s1.44 2.008 3.606 9.655c.347 1.23.765 2.608 1.148 4.146-.003.389.117.769.343 1.085 0 1.156.138 2.841-1.657 3.074z",
    fill: "#00A1FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M130.705 45.878a51.304 51.304 0 01-1.799-4.478l.789-2.225c.553 1.538 1.362 4.328 1.01 6.703zM136.86 48.253c-.789.521-1.613.513-2.075-.438-.935-1.921-.032-3.823.608-4.797.351 1.23.753 2.608 1.136 4.146-.013.39.104.773.331 1.09z",
    fill: "#000"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M113.32 50.57s7.891 2.824 15.411 2.3c0 0-.682-9.312-4.628-10.969-3.945-1.657-10.783.71-10.783 8.668z",
    fill: "#00A1FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M113.32 50.57s7.891 2.824 15.411 2.3c0 0-.682-9.312-4.628-10.969-3.945-1.657-10.783.71-10.783 8.668z",
    fill: "#000"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M114.439 51.232l13.02 1.125a46.313 46.313 0 011.385-9.564c.312-1.247.702-2.64 1.203-4.25.269-.86.565-1.783.896-2.761.248-.754.517-1.555.813-2.4a38.66 38.66 0 00-5.406-1.305 41.51 41.51 0 00-5.847-.616c-2.533 0-5.445.265-5.445.265s-.414.098-.674 2.785c-.233 2.505-.466 7.548.055 16.721z",
    fill: "#00A1FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M114.502 53.185l13.021 1.073c.205-3.235.359-7.607 1.333-11.465.312-1.247.702-2.64 1.204-4.25.268-.86.564-1.783.895-2.761.249-.754.517-1.555.813-2.4a38.68 38.68 0 00-5.405-1.305 41.51 41.51 0 00-5.848-.616c-2.533 0-5.444.265-5.444.265s-.415.098-.675 2.785c-.245 2.505-.418 9.5.106 18.674z",
    fill: "#2E353A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M121.58 34.326c3.212-.395 4.174-1.784 4.174-1.784-2.036-1.921-.343-5.251-.343-5.251l-3.863.722c.091.539.141 1.083.15 1.63.032 2.343-1.029 2.367-1.029 2.367-.679 1.266.911 2.316.911 2.316z",
    fill: "#B97964"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M121.547 28.013c.091.539.141 1.083.15 1.63 2.608 0 3.713-2.368 3.713-2.368l-3.863.738z",
    fill: "#000"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M123.686 17.206c-3.358-.181-4.537 1.559-4.972 5.003-.544 4.308.245 7.433 4.494 6.739 5.765-.935 6.057-11.434.478-11.742z",
    fill: "#B97964"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M120.889 22.142a7.001 7.001 0 01-1.053 1.338.93.93 0 00.868.43l.185-1.768z",
    fill: "#A24E3F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M122.961 21.98c0 .276.11.51.296.525.185.016.347-.197.371-.473.023-.277-.111-.51-.296-.525-.186-.016-.347.193-.371.473z",
    fill: "#2E353A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M123.412 21.527l-.584-.285s.261.53.584.285zM119.541 21.653c-.02.276.111.513.296.525.185.011.347-.198.371-.474.023-.276-.111-.509-.292-.525-.182-.015-.351.198-.375.474z",
    fill: "#2E353A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M119.99 21.2l-.584-.281s.261.529.584.28z",
    fill: "#2E353A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M123.125 19.66a1.75 1.75 0 011.428.588M120.685 19.388a1.576 1.576 0 00-1.353.201",
    stroke: "#2E353A",
    strokeWidth: 0.725,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M121.121 25.251c.138.386.248.782.328 1.184.073.004.147.004.221 0 .982-.044 1.42-.395 1.613-.758.09-.183.133-.384.126-.588a1.081 1.081 0 00-.043-.339c-.587.3-1.231.47-1.89.501h-.355z",
    fill: "#2E353A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M121.477 25.251l.106.347c.927-.043 1.578-.2 1.847-.493a1.113 1.113 0 00-.044-.34 4.617 4.617 0 01-1.909.486z",
    fill: "#fff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M121.668 26.435c.982-.044 1.42-.395 1.614-.758-.373.024-.74.113-1.081.265a1.181 1.181 0 00-.533.493z",
    fill: "#DE5753"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M127.046 23.07s-1.42-2.845-1.065-4.964c0 0-6.506-3.082-7.204 3.653 0 0-.324-6.032 5.456-5.85 5.78.18 5.295 8.628 2.174 10.98 0 0 1.515-2.032.639-3.82z",
    fill: "#2E353A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M126.457 23.748a1.464 1.464 0 01.569-.974 1.474 1.474 0 011.092-.285c1.034.17 1.412 2.332-1.184 2.707-.398.055-.588-.34-.477-1.448zM128.736 32.897s-3.771 3.058-7.259 3.007c-3.488-.051-4.735-3.993-4.735-3.993s5.417-1.614 11.994.986z",
    fill: "#B97964"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M128.41 32.321s-6.186 11.08.324 20.549c0 0 .883-11.683 3.026-19.503l-3.35-1.046zM117.061 31.445s-.056 7.84-1.184 10.752c-1.128 2.912-2.561 8.372-2.561 8.372s-1.089-13.06 1.05-18.86l2.695-.264z",
    fill: "#00A1FF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M125.98 18.106s-2.501-.864-4.703 0c-2.202.864-1.602 3.156-2.718 3.574",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M145.841 30.033l-1.034-.592-3.8 1.038-5.129-1.33-1.183 3.894s-.245 4.34 0 4.392c.244.051 5.871.343 5.871.343l2.86-1.823 2.415-5.922z",
    fill: "#E0E0E0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M134.495 29.441l-2.268 8.984 7.003.785 4.833-1.333 2.466-8.436-5.524 1.432-6.51-1.432z",
    fill: "#00A1FF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M141.005 30.873l-1.775 8.337-7.003-.785 2.268-8.984 6.51 1.432z",
    fill: "#fff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M141.002 30.873l-1.775 8.337 4.833-1.333 2.466-8.436-5.524 1.432z",
    fill: "#fff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M134.859 47.346l3.255-6.25a12.02 12.02 0 010-2.912c.198-1.578.198-1.929 1.444-1.799 1.247.13 2.896-.209 3.094.253.197.461-1.054 3.843-1.973 4.462l-1.914 6.246h-3.906z",
    fill: "#B97964"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M133.805 50.778c2.071 1.764 4.438.249 5.752-4.813l-4.075-.525-1.677 5.338z",
    fill: "#00A1FF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M135.692 44.328l-.833 1.467 5.161.695v-1.512l-4.328-.65zM93.352 36.752l1.428.9.935-5.121-1.511-.072-.852 4.293z",
    fill: "#2E353A"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M114.503 53.185l-8.206 48.214s19.861 2.367 26.592.986c0 0 1.654-34.515-5.373-48.135l-13.013-1.065z",
    fill: "#00A1FF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M114.503 53.185l-8.206 48.214s19.861 2.367 26.592.986c0 0 1.654-34.515-5.373-48.135l-13.013-1.065z",
    fill: "#fff"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M87.855 31.99l-2.044-2.11c-1.219-1.275-2.876-2.944-4.521-4.621l-2.434-2.446-2.127-2.135-1.503-1.507c-.182-.181-.328-.323-.422-.422a.34.34 0 00-.273-.024l.557-.56a.338.338 0 00.023.272l.426.422 1.515 1.496 2.139 2.119 2.462 2.422c1.685 1.637 3.361 3.287 4.64 4.502l2.122 2.032-.56.56z",
    fill: "#2E353A"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M102.962 119.201s-2.083 4.364-3.286 5.208c0 0 1.61.959 3.286-1.184 2.17-2.762 2.699-1.972 2.699-1.972a7.736 7.736 0 00-.26-1.409c-.328-.904-2.439-.643-2.439-.643zM120.807 119.154s-.592 1.617-1.381 3.393a7.664 7.664 0 01-1.578 2.477s1.373.446 2.11-.414c.738-.86 2.005-3.945 3.425-3.606a3.22 3.22 0 00-.315-.722c-.214-.339-2.261-1.128-2.261-1.128z",
    fill: "#B97964"
  })));
}
export default __webpack_public_path__ + "static/media/teachers.eb471ae1.svg";
export { SvgTeachers as ReactComponent };